var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('div',{staticClass:"row container q-px-sm",class:{
      simpleButtons: _vm.rowButtons,
      crudButtons: !_vm.rowButtons,
      cleanLayout: _vm.cleanLayout,
    }},[_c('div',{staticClass:"fit"},[_c('crud-layout-search',{ref:"crudLayoutSearch",attrs:{"name":_vm.name,"interface":_vm.nmInterface,"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }